import React, { useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import { GridReportView } from './GridReportViewer';
import { Report } from 'core/slices/models';

type GridActiveReportsProps = {
  selectedReport: string;
  activeProjectKey: string;
  activeReport: Report;
};

export const GridActiveReports: React.FC<GridActiveReportsProps> = ({
  selectedReport,
  activeProjectKey,
  activeReport,
}) => {
  // Use ref to track if we've already sent the GA event for this report
  const sentGARef = useRef<string | null>(null);

  useEffect(() => {
    if (selectedReport && selectedReport !== sentGARef.current) {
      ReactGA.send({
        hitType: 'pageview',
        page: `/reports/grid/${selectedReport}`,
        title: `Grid: ${activeReport.name}`,
      });

      sentGARef.current = `${selectedReport}`;
    }
  }, [selectedReport, activeReport.name]);

  return (
    <GridReportView
      key={`${activeProjectKey}/${selectedReport}`}
      selectedReport={selectedReport}
      activeReport={activeReport}
      activeProjectKey={activeProjectKey}
    />
  );
};
